import { useState } from "react";
import api from "../lib/api";

export default function ReelForm() {
  const [f, setF] = useState({ name: "", email: "", org: "", date: "", message: "" });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email) { setErr("Full name and email are required."); return; }
    try {
      await api.post("/leads", {
        first_name: f.name, email: f.email, organization: f.org, event_date: f.date, message: f.message,
        interests: ["Speaker booking / reel request"], source_page: window.location.pathname,
      });
      setDone(true);
    } catch { setErr("Something went wrong. Please try again."); }
  };

  const field = "w-full bg-transparent border border-sage/40 px-4 py-3 text-sm outline-none focus:border-forest placeholder:text-ink/40";
  if (done) {
    return (
      <div className="py-10 text-center" data-testid="reel-confirmation">
        <p className="text-5xl text-gold mb-3"><span className="font-sign">thank</span><span className="font-headline italic text-[0.62em] ml-2">you</span></p>
        <p className="font-headline italic text-xl text-ink/70">We'll be in touch shortly, with the speaker reel.</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} data-testid="reel-form" className="grid sm:grid-cols-2 gap-3">
      <input data-testid="reel-name" required value={f.name} onChange={set("name")} placeholder="Full name *" className={field} />
      <input data-testid="reel-email" type="email" required value={f.email} onChange={set("email")} placeholder="Email *" className={field} />
      <input data-testid="reel-org" value={f.org} onChange={set("org")} placeholder="Event or organization" className={field} />
      <input data-testid="reel-date" value={f.date} onChange={set("date")} placeholder="Event date (optional)" className={field} />
      <textarea data-testid="reel-message" value={f.message} onChange={set("message")} rows={4}
        placeholder="Tell us about your event (date, audience size, format, topic, anything else)" className={`${field} sm:col-span-2 resize-none`} />
      {err && <p className="text-sm text-red-600 sm:col-span-2" data-testid="reel-error">{err}</p>}
      <button type="submit" data-testid="reel-submit" className="btn-lux sm:col-span-2 w-full sm:w-fit text-center bg-ink text-ivory hover:bg-gold hover:text-ink mt-2">Send request</button>
    </form>
  );
}
